Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-warehouse-search', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-warehouse-search', $context),
            $content = $('.search-warehouse-wrapper', $control);

        if ($control.length < 1)
            return;

        var control = $control.get(0);
        control.HasGoogleMapsInitialized = ((window.google || {}).maps != undefined) && !($content.data("force-not-use-google-map"));
        control.EnableTrackingLocation = ($content.data("enable-tracking-location"));
        control.myLocation = { latitude: 0, longitude: 0 };

        control.skuId = $content.data("skuid");
        control.skuCode = $content.data("skucode");
        var ignoreAvailability = $content.data("ignore-availability");
        control.ignoreAvailability = ignoreAvailability || ignoreAvailability === "True" ? true : false;
        var lazyloadAvailabilities = $content.data("lazyload-availabilities");
        control.lazyloadAvailabilities = lazyloadAvailabilities === "True" ? true : false;
        var geoLocationWithZipCode = $content.data("use-zipcode");
        control.geoLocationWithZipCode = geoLocationWithZipCode || geoLocationWithZipCode === "True" ? true : false;
        control.topAvailableWarehouse = $content.data("top-warehouses") || 0;
        control.groupBy = $content.data("group-by") || "";
        control.latestLocation = { latitude: 0, longitude: 0 };
        control.productAddedService;
        control.setStoreService;
        control.setDeliveryPointService;

        var sSelect = null, selectedWarehouse, selectedWarehouseAvailability;

        $content.on('keyup', 'input', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                $('.js-submit', $content).trigger('click');
                return;
            }
        });

        $content.on('click', '.js-submit', function (e) {

            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass("disabled")) return;
            if ($content.hasClass('x-loading')) return;
            $content.addClass('x-loading');

            var searchTerm = $('.js-search-term', $content).val();
            var maxDistance = parseInt($('.js-distance-range', $content).val()) || 0;
            var hasGeolocation = $(this).hasClass("near-my-location") && control.myLocation.latitude > 0 && control.myLocation.longitude > 0 && control.EnableTrackingLocation;
            if (
                ((!hasGeolocation && control.searchTerm == searchTerm) || hasGeolocation) &&
                control.maxDistance == maxDistance &&
                control.hasGeolocation == hasGeolocation &&
                ((hasGeolocation && control.myLocation.latitude == control.latestLocation.latitude && control.myLocation.longitude == control.latestLocation.longitude) || !hasGeolocation)
            ) {
                $content.removeClass('x-loading');
                return;
            }

            var location = hasGeolocation ? control.myLocation : null;
            control.latestLocation = hasGeolocation ? _.clone(location) : control.latestLocation;
            control.searchTerm = searchTerm;
            control.maxDistance = maxDistance;
            control.hasGeolocation = hasGeolocation;

            var vendd = getParentOrSelfVendd();
            var state = Cookies.get('VisitorState'), countryCode = "";
            if (state) {
                var parameters = state.split("&");
                if (state.indexOf("countryCode") >= 0) {
                    for (var i = 0; i < parameters.length; i++) {
                        var pair = parameters[i].split("=");
                        if (pair[0] == "countryCode") {
                            countryCode = pair[1];
                        }
                    }
                }
            }

            vendd.MessageBus.publishAsync(control, new vendd.Product.Messages.GetAvailableWarehouses(control.skuId, control.skuCode, countryCode, control.searchTerm, maxDistance, control.ignoreAvailability, control.geoLocationWithZipCode, control.topAvailableWarehouse, control.groupBy, location));
        });

        $('.js-show-warehouses-search', $control).fancybox({
            padding: 0,
            width: 450,
            touch: false,
            beforeShow: function () {
                if ($content.hasClass('has-warehouse-grouping')) {
                    $('.js-get-warehouses .js-submit').trigger('click');
                }
            },
            afterShow: function () {
                if (!sSelect) sSelect = $('.form-row select', $content).sSelect();

                if (navigator.geolocation && control.EnableTrackingLocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            $('.js-submit.near-my-location', $content).toggleClass("disabled", false);
                            control.myLocation.latitude = position.coords.latitude;
                            control.myLocation.longitude = position.coords.longitude;

                            var options = {
                                enableHighAccuracy: false,
                                //timeout: 5000,
                                maximumAge: 0
                            };
                            var id = navigator.geolocation.watchPosition(
                                function (position) {
                                    $('.js-submit.near-my-location', $content).toggleClass("disabled", false);
                                    control.myLocation.latitude = position.coords.latitude;
                                    control.myLocation.longitude = position.coords.longitude;
                                }, function (error) {
                                    $('.js-submit.near-my-location', $content).toggleClass("disabled", true);
                                    control.myLocation = { latitude: 0, longitude: 0 };
                                }, options);
                        },
                        function () {
                            $('.js-submit.near-my-location', $content).toggleClass("disabled", true);
                            control.myLocation = { latitude: 0, longitude: 0 };
                        });
                } else {
                    $('.js-submit.near-my-location', $content).toggleClass("disabled", true);
                    control.myLocation = { latitude: 0, longitude: 0 };
                }
            }
        });

        control.bindWarehouses = function (model) {
            if (control.HasGoogleMapsInitialized && control.maxDistance > 0 && model.WarehousesGrouped.length > 0) {
                var vendd = getParentOrSelfVendd();
                var searchTerm = control.hasGeolocation && control.myLocation.latitude > 0 && control.myLocation.longitude > 0 ? control.myLocation.latitude + "," + control.myLocation.longitude : control.searchTerm;
                vendd.MessageBus.publishAsync(control, new vendd.Store.Messages.CalculateDistances(model.WarehousesGrouped, searchTerm, control.maxDistance));
            } else {
                control.bind(model);
            }
        };

        control.bindAvailabilities = function (model) {
            //set Array with product info
            var variantArray = [];
            var variant = {
                VariantId: control.skuId,
                Quantity: $('.qty-spinner-input').val() || 1
            };
            variantArray.push(variant);

            //call service for availabilities
            Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.GetPickUpAvailability(variantArray, null, false));

            //merge models on service success
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetPickUpAvailabilitySuccess, control, function (envelope) {
                var data = envelope.message.data;

                var pickUpAvailabilities = _.each(model.WarehousesGrouped, function (group) {
                    _.each(group.Items, function (warehouse) {
                        var selectedWarehouse = _.find(data.PickupAvailabilities[0].Shops, function (x) { return warehouse.PartnerId === x.PartnerId })
                        if (selectedWarehouse) {
                            if (selectedWarehouse.Days == null) {
                                warehouse.AvailabilityActionId = 1;
                            } else {
                                warehouse.AvailabilityActionId = 3;
                            } 
                            warehouse.AvailabilityActionName = selectedWarehouse.Message;
                        } 
                    });
                });
                _.extend(model.WarehousesGrouped, pickUpAvailabilities);

                control.bindWarehouses(control.warehousesModel);

                Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.GetPickUpAvailabilitySuccess, control);
            });

        };

        control.evaluateDistances = function (model) {

            var data = control.distanceData,
                top = parseInt($content.data('top-warehouses')),
                showOffRangeWareHouses = true;
            model.ErrorCalculatingDistances = false;

            if (data && data.DistanceMeasured) {
                if (model.WarehousesGrouped.length == 0) return model;
                var warehousesGroups = _.sortBy(data.array, function (group) { return (_.min(group.Items, function (item) { return item.Distance; }) || {}).Distance || 0; });
                for (var group = 0; group < warehousesGroups.length; group++) {
                    var warehouses = warehousesGroups[group].Items || [];
                    warehouses = _.sortBy(warehouses, function (item) { return item.Distance; });
                    var hasWareHouses = false;
                    for (var i = 0; i < warehouses.length; i++) {
                        if (data.TotalFindInRange > 0) {
                            warehouses[i].Show = warehouses[i].IsWithinRange;
                        } else if (showOffRangeWareHouses) {
                            warehouses[i].Show = (i < top);
                        }
                        hasWareHouses = hasWareHouses || warehouses[i].Show;
                        warehouses[i].AvailabilityCustomText = LhApp.Text["Common:AvailabilityWarehouse_" + warehouses[i].AvailabilityId];
                    }
                    warehousesGroups[group].Items = warehouses;
                    warehousesGroups[group].HasWareHouses = hasWareHouses;
                }
                model.WarehousesGrouped = warehousesGroups;
                model.HasWareHouses = data.TotalFindInRange > 0 || (showOffRangeWareHouses && model.Warehouses && model.Warehouses.length > 0);
            } else if (model.WarehousesGrouped && model.WarehousesGrouped.length) {
                for (var group = 0; group < model.WarehousesGrouped.length; group++) {
                    for (var i = 0; i < model.WarehousesGrouped[group].Items.length; i++) {
                        model.WarehousesGrouped[group].Items[i].Show = true;
                        model.WarehousesGrouped[group].Items[i].AvailabilityCustomText = LhApp.Text["Common:AvailabilityWarehouse_" + model.WarehousesGrouped[group].Items[i].AvailabilityId];
                    }
                    model.WarehousesGrouped[group].HasWareHouses = true;
                }
                model.ErrorCalculatingDistances = true;
                model.HasWareHouses = true;
            }
            return model;
        };

        control.hideForm = function () {
            $('.js-warehouse-search-form', $content).hide();
            $('.form-msg .js-error', $content).show();
        };

        control.bind = function (model) {
            model = control.evaluateDistances(model);
            //set warehouse as disabled if product is unavailable
            _.each(model.WarehousesGrouped, function (group, i) {
                _.each(group.Items, function (warehouse, j) {
                    if (warehouse.AvailabilityActionId == 1) {
                        warehouse.isDisabled = true;
                    }
                });
            });

            /*if ( model.ErrorCalculatingDistances ) control.hideForm();*/
            if (!model.NoWarehouseFound) model.NoWarehouseFound = LhApp.Function.getText('Common:Master_SomeError');
            var html = Vendd.Handlebars.parse("pdWarehouseSearchResults_A", model);

            var $container = $('.x-search-warehouses', $content);

            $container.html(html);
            $container.removeClass('empty');

            if (!isTouch()) {
                $(".content", $container).mCustomScrollbar({
                    scrollbarPosition: "inside",
                    scrollInertia: 400,
                    theme: "grey",
                    mouseWheel: { preventDefault: true }
                });
            }
            
            $content.removeClass('x-loading');

            $container.on('click', '.js-toggle-group', function (e) {

                e.preventDefault();
                e.stopPropagation();

                var $this = $(this);
                var tab = $this.data('tab');

                if ($this.hasClass('active')) {
                    return;
                } else {
                    $('.js-toggle-group', $container).removeClass('active');
                    $('.warehouse-list', $container).removeClass('active');
                    $this.addClass('active');
                    $('.warehouse-list:eq(' + tab + ')', $container).addClass('active');
                }

            });

            $('input[name="warehouse"]', $container).on('click', function () {
                selectedWarehouse = $(this).val();
                selectedWarehouseAvailablity = $(this).siblings('.warehouse-info').find('.availability');
                if (selectedWarehouse > 0) {
                    $('.js-proceed-to-checkout', $content).removeClass('disabled');
                    $('.js-continue-shopping', $content).removeClass('disabled');
                }
            });

        };

        $content.on('click', '.js-proceed-to-checkout, .js-continue-shopping', function (e) {

            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);
            var cartRedirect = false;
            var deliveryPointId = 2;
            //Set the three services
            control.productAddedService = $.Deferred();
            control.setStoreService = $.Deferred();
            control.setDeliveryPointService = $.Deferred();

            //If all three services run successful, proceed to final action
            $.when(control.productAddedService, control.setStoreService, control.setDeliveryPointService)
                .done(function (productAddedResponse, setStoreResponse, setDeliveryPointResolve) {

                    if (control.lazyloadAvailabilities) {
                        //Remove cookie for Delivery Postal Code
                        var deliveryPostalCode = Cookies.get('DeliveryPostalCode');
                        if (deliveryPostalCode && deliveryPostalCode !== 'undefined') {
                            Cookies.remove('DeliveryPostalCode');
                        }

                        //Show Pick Up Availability                                      
                        $('.x-product-details .lazyload-availability-container > span').remove();
                        $('.x-product-details .lazyload-availability-container').append(selectedWarehouseAvailablity);
                    }
                                            
                    //get model of delivery point
                    if ($('.x-deliverypoint-widget-a').length > 0) {
                        Vendd.MessageBus.publish($('.x-deliverypoint-widget-a'), new Vendd.DeliveryPoint.Messages.GetModel());
                    }
                    
                    if (cartRedirect) {
                        //Redirect user to Cart page
                        document.location = LhApp.Url.Page.Cart;
                    } else {
                        //Close fancybox
                        $('[data-fancybox-close]', $content).trigger('click');
                    }
                });

            //If proceed to checkout -> redirect true
            if ($this.hasClass('js-proceed-to-checkout')) cartRedirect = true; 

            //trigger add to cart button in order to add sku in cart                
            $('.x-product-details-ajax-buttons.desktop .js-add-to-cart').trigger('click');
            //If product added successfully -> Resolve
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ProductAdded, 'x-product-details', function (envelope) { control.productAddedService.resolve(envelope); });
            //if product failed to added -> Reject
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, 'x-product-details', function (envelope) { control.productAddedService.reject(); });

            //Function for SetStore Service ajax call
            setStore(cartRedirect, selectedWarehouse);

            //Function for setDeliveryPoint Service ajax call
            setDeliveryPoint(cartRedirect, deliveryPointId);
        });

        //SetStore Service ajax call
        function setStore(cartRedirect, selectedWarehouse) {
            $.ajax({
                // async: false,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                ContentType: 'application/json; charset=UTF-8',
                url: LhApp.Function.Url.getServiceEndpoint('checkoutservice.svc/SetStore?lang=el'),
                data: JSON.stringify({
                    data: "",
                    arguments: JSON.stringify({
                        "Id": selectedWarehouse
                    })
                }),
                success: function (response) {
                    //Resolve
                    control.setStoreService.resolve(response);
                },
                error: function (ex) {
                    control.setStoreService.reject();
                    console.log("error");
                }
            });
        }

        //setDeliveryPoint Service ajax call
        function setDeliveryPoint(cartRedirect, deliveryPointId) {
            $.ajax({
                type: "post",
                url: "/Services/api/DeliveryPoint/SetDeliveryPoint",
                data: {
                    deliveryPointId: deliveryPointId
                },
                dataType: "json",
                statusCode: {
                    200: function (response) {
                        //Resolve
                        control.setDeliveryPointService.resolve(response);
                    },
                    404: function (response) {
                        control.setDeliveryPointService.reject();
                        console.log("error");
                    },
                    500: function (response) {
                        control.setDeliveryPointService.reject();
                        console.log("error");
                    }
                }
            });
        }

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetAvailableWarehousesSuccess, control, function (envelope) {
            var data = envelope.message.data;
            control.warehousesModel = envelope.message.data;

            if (control.lazyloadAvailabilities) {
                control.bindAvailabilities(control.warehousesModel);                
            } else {
                control.bindWarehouses(control.warehousesModel);               
            }
            
        });

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetAvailableWarehousesFailure, control, function (envelope) {
            control.warehousesModel = {};
            control.bindWarehouses(control.warehousesModel);
        });

        Vendd.MessageBus.subscribe(Vendd.Store.Messages.CalculateDistancesSuccess, control, function (envelope) {

            var sender = envelope.message.data.sender;
            if (control && sender && control == sender) {
                control.distanceData = envelope.message.data.model;
                control.bind(control.warehousesModel);
            }
        });

    });

});